module.exports = __webpack_public_path__ + "media/images/top/ranking-sample03-8835e9e002d7d50a67055acb7c10f24a.jpg";